import { render, staticRenderFns } from "./mensagemErroGrande.vue?vue&type=template&id=15a0bbbe&scoped=true&"
import script from "./mensagemErroGrande.vue?vue&type=script&lang=js&"
export * from "./mensagemErroGrande.vue?vue&type=script&lang=js&"
import style0 from "./mensagemErroGrande.vue?vue&type=style&index=0&id=15a0bbbe&scoped=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15a0bbbe",
  null
  
)

export default component.exports